
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[brandAlias]",
      function () {
        return require("private-next-pages/[brandAlias]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[brandAlias]"])
      });
    }
  